// extracted by mini-css-extract-plugin
export var checkbox = "_7m-0";
export var circle = "_7m-3";
export var horizontalContainer = "_7m-7";
export var sm = "_7m-5";
export var switch0 = "_7m-2";
export var switchDisabled = "_7m-8";
export var switchEnabled = "_7m-1";
export var textSwitchContainer = "_7m-9";
export var textSwitchOption = "_7m-a";
export var textSwitchOptionSelected = "_7m-b";
export var verticalContainer = "_7m-6";
export var xs = "_7m-4";